<template>
    <div :class="breakpoint ? 'fixed-bottom-right' : `wrapper-${ratio}`" :elevation="24">
        <iframe
            :class="breakpoint ? '' : 'absolute'"
            :width="breakpoint ? width : '100%'"
            :height="breakpoint ? height : '100%'"
            :src="src"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
export default {
    name: "VideoEmbed",
    props: {
        src: {
            type: String,
            default: () => '',
            required: true
        },
        ratio: {
            type: String,
            default: () => '16x9'
        },
        width: {
            type: Number,
            default: () => 356
        }
    },
    computed: {
        height() {
            const aspect = this.ratio.split('x')[0] / this.ratio.split('x')[1];
            const height = this.width / aspect;
            return height;
        },
        breakpoint() {
            const value = 1000 + this.width + (this.width * 0.1);
            const breakpoint = this.$vuetify.breakpoint.width >= value;
            return breakpoint;
        }
    }
}
</script>

<style scoped>
.fixed-bottom-right {
    position: fixed;
    bottom: 4%;
    right: 2.5%;
}
.wrapper-16x9 {
   position: relative;
   width: 100%;
   height: 0;
   padding-bottom: 56.25%;
}
.wrapper-1x1 {
   position: relative;
   width: 100%;
   height: 0;
   padding-bottom: 100%;
}
.absolute {
   position: absolute;
   left: 0;
   top: 0;
   height: 100%;
   width: 100%;
}

</style>

<style>
div.ytp-chrome-top {
    z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoEmbed.vue